var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiateurGaz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.19 230.605L218.44 205.675V102.905L176.19 127.825V230.595V230.605Z",
    fill: "#29A063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.19 230.605L31.5601 147.095V44.335L176.19 127.825V230.595V230.605Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8101 19.395L31.5601 44.325L176.19 127.815L218.44 102.895L73.8101 19.395Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.38 30.7051L50.8101 45.925L54.95 48.3051L80.23 32.925",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.03 62.8049L106.46 78.0149L110.6 80.405L135.88 65.0249",
    fill: "#B2E8C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.55 37.0649L61.98 52.285L66.12 54.665L91.4 39.285",
    fill: "#B2E8C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6499 43.5352L73.0798 58.7451L77.2198 61.1351L102.5 45.7551",
    fill: "#B2E8C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.78 49.9648L84.21 65.1749L88.35 67.5648L113.63 52.1848",
    fill: "#B2E8C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.89 56.385L95.3198 71.595L99.4598 73.9849L124.74 58.605",
    fill: "#B2E8C5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M176.54 88.5049L150.97 103.715L155.11 106.105L180.39 90.7251",
    fill: "#B2E8C5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M187.66 94.925L162.09 110.135L166.23 112.525L191.51 97.145",
    fill: "#B2E8C5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.15 69.2349L117.58 84.4451L121.72 86.835L147 71.4551",
    fill: "#B2E8C5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.28 75.655L128.71 90.865L132.85 93.2549L158.13 77.875",
    fill: "#B2E8C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.38 82.075L139.81 97.2849L143.95 99.675L169.23 84.2949",
    fill: "#B2E8C5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198.63 178.805L195.68 178.195L195.25 157.875L198.07 158.365L198.63 178.805Z",
    fill: "#B2E8C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199.66 166.345L195.67 168.645L198.07 158.365L202.18 155.555L199.67 166.335L199.66 166.345Z",
    fill: "#72D09A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199.4 155.105L195.3 157.875L198.07 158.375L202.18 155.565L199.4 155.105Z",
    fill: "#72D09A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M202.62 176.505L198.63 178.805L195.68 168.695L199.67 166.395L202.62 176.505Z",
    fill: "#72D09A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5895 152.783C92.6205 152.814 92.6823 152.876 92.6823 152.876C92.7752 152.814 92.7132 152.752 92.6513 152.721C91.9086 151.272 90.9182 149.978 90.3302 148.405C89.4636 146.124 89.1852 143.904 90.2684 141.685C91.1349 139.866 92.1872 138.108 92.868 136.197C92.9299 136.012 93.0227 135.858 93.1156 135.673C93.2703 135.426 93.4561 135.334 93.6417 135.642C94.6012 137.06 95.5605 138.478 95.9009 140.205C96.0557 141.006 96.3343 141.746 96.6128 142.671C99.3363 138.848 100.079 134.717 99.7385 130.216C100.45 130.586 100.543 131.203 100.853 131.665C101.843 133.052 102.864 134.409 103.607 135.981C104.35 137.554 105.278 139.002 105.804 140.698C106.331 142.424 107.042 144.059 107.197 145.908C107.383 148.036 107.599 150.101 106.857 152.197C106.269 153.862 105.619 155.434 104.102 156.513C103.576 156.883 102.988 157.192 102.369 157.562C103.762 158.086 105.186 158.117 106.423 157.778C108.559 157.223 110.292 155.959 111.22 153.831C112.118 151.766 111.994 149.577 111.994 147.419C111.963 145.723 111.53 144.028 111.19 142.394C110.818 140.698 110.199 139.033 109.549 137.399C108.899 135.765 108.126 134.162 107.383 132.59C106.64 131.049 105.65 129.63 104.845 128.12C104.04 126.609 102.957 125.253 102.06 123.804C100.574 121.461 98.934 119.21 97.3866 116.929C97.0461 116.405 96.6747 115.911 96.3652 115.356C96.1176 114.863 95.7771 114.37 95.251 114C94.9724 115.202 94.6631 116.343 94.137 117.422C93.4561 118.778 92.93 120.227 92.1253 121.522C90.7326 123.711 89.0922 125.684 87.5138 127.75C85.2236 130.709 83.7072 134.008 84.0477 137.893C84.2024 139.681 84.3572 141.469 85.1309 143.164C85.5642 144.12 86.0593 145.076 86.5854 145.97C88.1947 148.498 90.0517 150.933 92.5895 152.783Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiateurGaz);
export default __webpack_public_path__ + "static/media/radiateurGaz.4958ebdade6911633db46cef2cda0c73.svg";
export { ForwardRef as ReactComponent };